var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackagingplant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0256 5.56558L8.55285 0.130864C8.43654 0.0459467 8.29612 0 8.15207 0C8.00803 0 7.8676 0.0459467 7.7513 0.130864L0.278563 5.56558C0.102967 5.69387 -0.000602942 5.89843 2.64102e-06 6.11589V15.6266C2.64102e-06 15.8068 0.0715779 15.9797 0.198952 16.107C0.326326 16.2344 0.499197 16.306 0.679343 16.306H2.71736V10.1919C2.71736 10.0118 2.78894 9.83891 2.91631 9.71154C3.04369 9.58416 3.21656 9.51259 3.3967 9.51259H12.9075C13.0876 9.51259 13.2605 9.58416 13.3879 9.71154C13.5152 9.83891 13.5868 10.0118 13.5868 10.1919V16.306H15.6248C15.805 16.306 15.9778 16.2344 16.1052 16.107C16.2326 15.9797 16.3042 15.8068 16.3042 15.6266V6.11589C16.3048 5.89844 16.2012 5.69388 16.0256 5.56558ZM9.51091 6.79523H6.79355C6.55078 6.79523 6.32651 6.66573 6.2052 6.45556C6.08389 6.24539 6.08389 5.98639 6.2052 5.77622C6.32651 5.56605 6.55078 5.43655 6.79355 5.43655H9.51091C9.75368 5.43655 9.97795 5.56605 10.0993 5.77622C10.2206 5.98639 10.2206 6.24539 10.0993 6.45556C9.97795 6.66573 9.75367 6.79523 9.51091 6.79523Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07422 10.8721H12.2263V12.9101H4.07422V10.8721Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07422 14.2686H12.2263V16.3066H4.07422V14.2686Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagingplant);
export default __webpack_public_path__ + "static/media/packagingplant.5cdc105e2380234f75a5b8faca789e2d.svg";
export { ForwardRef as ReactComponent };